import styled from 'styled-components/macro';
import { default as size } from 'utils/scale-size';
import { StyledFocusableActionsWrapper } from 'components/Modal/StyledComponents';

export const StyledPageLayout = styled.div`
  padding-left: ${size(220)}px;
  padding-right: ${size(150)}px;
  padding-top: ${size(160)}px;
`;

export const StyledPageContent = styled.div`
  font-family: Roboto, sans-serif;
  color: ${({ theme }) => theme.mainTextColor};
  transform: translate3d(0, ${({ pageOffset = 0 }) => pageOffset}px, 0);
`;

export const StyledPackageTitle = styled.h1`
  font-size: ${size(72)}px;
  font-weight: 500;
  line-height: 1.22;
  color: ${({ theme }) => theme.defaultColor};
  padding-bottom: ${size(52)}px;
  margin: 0;
`;

export const StyledPackageDescription = styled.div`
  font-size: ${size(34)}px;
  line-height: 1.41;
  padding-bottom: ${size(64)}px;
`;

export const StyledActions = styled(StyledFocusableActionsWrapper)`
  height: auto;
  text-align: left;
`;

export const StyledPackagePrice = styled.span`
  font-size: ${size(34)}px;
  font-weight: 500;
  color: ${({ theme }) => theme.defaultColor};
  margin-left: ${size(20)}px;
`;

export const StyledListWrapper = styled.div`
  margin-top: ${size(80)}px;
`;
